/**
 * A sign-up refusal said the way a person on a phone needs to hear it.
 *
 * Cognito's messages are written for developers: "Password did not conform with policy: Password
 * must have numeric characters", "1 validation error detected: Value at 'password' failed to
 * satisfy constraint: Member must satisfy regular expression pattern: ^[\S]+.*[\S]+$". Matched by
 * the error's code (api/auth.ts keeps Cognito's name on it), and only for the refusals whose
 * meaning is certain; anything else is passed through as Cognito said it, because a message
 * guessed wrong sends somebody to fix the wrong thing.
 */
export function signUpRefusal(err: unknown): string {
  const code = (err as { code?: string } | null)?.code;
  const message = err instanceof Error ? err.message : '';
  switch (code) {
    case 'InvalidPasswordException':
      return 'That password needs at least 8 characters, a lowercase letter and a number.';
    case 'InvalidParameterException':
      // The same code covers the email and the password; the message says which.
      if (/password/i.test(message)) return 'Passwords can’t start or end with a space.';
      if (/email/i.test(message)) return 'That email address doesn’t look right. Check it and try again.';
      break;
    case 'TooManyRequestsException':
    case 'LimitExceededException':
      return 'Too many tries just now. Wait a minute, then try again.';
    case 'NetworkError':
      return 'We couldn’t reach Saddle. Check your connection and try again.';
  }
  return message || 'We couldn’t create your account. Try again.';
}
